import { render } from "./App.vue?vue&type=template&id=31addf3a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=31addf3a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__